import { mapState, mapGetters, mapActions } from "vuex";
import ConnectionPageTitle from "@/components/ConnectionPageTitle";
import AppCardConnections from "@/components/AppCardConnections";
import AppButton from "@/components/AppButton";
import AppIcon from "@/components/AppIcon";
import AppModal from "@/components/AppModal";
import CustomSideBarAppModal from "@/components/CustomSideBarAppModal";
import CreateAccountSideBar from "@/components/CreateAccountSideBar";
import AdvertisingAccountSideBar from "@/components/AdvertisingAccountSideBar";
import DSPAccountSideBar from "@/components/DSPAccountSideBar";
import { country_codes } from "@/utils/countries";
import AccountConnectionStatus from "@/components/AccountConnectionStatus.vue";
import AdvertisingAccountWithFlag from "@/components/AdvertisingAccountWithFlag.vue";
import StrokedPlusIcon from "@/components/icons/StrokedPlusIcon.vue";
import WrapWithCopy from "@/components/WrapWithCopy.vue";
import AppPopover from "@/components/AppPopover";
import TasksMixin from "@/mixins/TasksMixin.vue";
import AccountsMixin from "@/mixins/AccountsMixin.vue";
export default {
  name: "AmazonConnectionPage",
  emits: ["update-total"],
  mixins: [AccountsMixin, TasksMixin],
  components: {
    ConnectionPageTitle,
    AppCardConnections,
    AppButton,
    AppIcon,
    AppModal,
    CustomSideBarAppModal,
    CreateAccountSideBar,
    AdvertisingAccountSideBar,
    DSPAccountSideBar,
    AccountConnectionStatus,
    AdvertisingAccountWithFlag,
    StrokedPlusIcon,
    WrapWithCopy,
    AppPopover
  },
  data() {
    return {
      dataLoading: true,
      removeLoading: false,
      nameEditLoading: false,
      searchPlaceHolder: "Search",
      accountRemoveTaskIdentifier: "",
      accountsList: [],
      sideBarAccount: {},
      confirmRemoveModal: false,
      removeId: null,
      createAccountSideBar: false,
      advertisingAccountSideBar: false,
      dspAccountSideBar: false,
      accountNameEditId: "",
      updatedAccount: {},
      confirmAccountNameEditModal: false,
      regions: [{
        text: "Choose a region to connect",
        value: ""
      }, {
        text: "North America",
        value: "North America"
      }, {
        text: "Europe & Middle East",
        value: "Europe & Middle East"
      }, {
        text: "Far East",
        value: "Far East"
      }],
      countries: {
        "": [{
          text: "Choose a country",
          value: ""
        }],
        "North America": [{
          text: "Brazil",
          value: "Brazil"
        }, {
          text: "US",
          value: "US"
        }, {
          text: "Mexico",
          value: "Mexico"
        }, {
          text: "Canada",
          value: "Canada"
        }],
        "Europe & Middle East": [{
          text: "Spain",
          value: "Spain"
        }, {
          text: "Belgium",
          value: "Belgium"
        }, {
          text: "UK",
          value: "UK"
        }, {
          text: "France",
          value: "France"
        }, {
          text: "Netherlands",
          value: "Netherlands"
        }, {
          text: "Germany",
          value: "Germany"
        }, {
          text: "Italy",
          value: "Italy"
        }, {
          text: "Sweden",
          value: "Sweden"
        }, {
          text: "Egypt",
          value: "Egypt"
        }, {
          text: "Poland",
          value: "Poland"
        }, {
          text: "Turkey",
          value: "Turkey"
        }, {
          text: "Saudi Arabia",
          value: "Saudi Arabia"
        }, {
          text: "U.A.E",
          value: "U.A.E"
        }, {
          text: "India",
          value: "India"
        }, {
          text: "Ireland",
          value: "Ireland"
        }],
        "Far East": [{
          text: "Singapore",
          value: "Singapore"
        }, {
          text: "Australia",
          value: "Australia"
        }, {
          text: "Japan",
          value: "Japan"
        }]
      },
      account_provider_mapping: {
        "/amz-seller-central": "Amazon Seller Central",
        "/amz-vendor-central": "Amazon Vendor Central"
      },
      accountTypes: {
        "Amazon Seller Central": "seller",
        "Amazon Vendor Central": "vendor"
      },
      sortAscending: true,
      sortType: ""
    };
  },
  props: {
    provider: {
      type: String,
      default: ""
    },
    search: String,
    page: {
      type: Number,
      default: 1
    },
    perPage: {
      type: Number,
      default: 20
    }
  },
  computed: {
    ...mapState({
      me: state => state.auth.me,
      isOmnyAdmin: state => state.auth.isOmnyAdmin,
      isOmnyUser: state => state.auth.isOmnyUser,
      isClientAdmin: state => state.auth.isClientAdmin,
      isClientUser: state => state.auth.isClientUser,
      isOmnyWorkspace: state => state.workspace.isOmnyWorkspace,
      current_workspace: state => state.workspace.current_workspace,
      account: state => state.account.list
    }),
    ...mapGetters(["accountByProviderGet", "workspaceNameById", "accountAdvertisingBySellerIdGet", "accountAdvertisingByDSPProfileIdGet"]),
    canAddAccount() {
      return (this.isOmnyAdmin || this.isClientAdmin || this.isOmnyUser || this.isClientUser) && !this.isOmnyWorkspace;
    },
    processedRegion() {
      return account => {
        return account.region == "Europe" ? "EU" : account.region == "Europe & Middle East" ? "EMEA" : account.region == "North America" ? "NA" : "FE";
      };
    },
    accounts() {
      this.accountsList = this.account.filter(a => a.account_provider != "Amazon Advertising" && a.account_provider != "Amazon DSP Advertising").filter(this.searchFilter).sort(this.accountsSort);
      const startIndex = (this.page - 1) * this.perPage;
      const endIndex = startIndex + this.perPage;
      return this.accountsList.slice(startIndex, endIndex);
    }
  },
  async created() {
    //this.provider = this.account_provider_mapping[this.$route.matched[1].path];
    let currentBreadCrumbs = this.$store.getters.getCurrentBreadCrumbs();
    // currentBreadCrumbs[currentBreadCrumbs.length - 1].text = this.provider;
    this.$store.dispatch("setBreadcrumbs", currentBreadCrumbs);
  },
  async mounted() {
    //this.provider = this.account_provider_mapping[this.$route.matched[1].path];
    var is_authenticated = await this.authStatus();
    if (is_authenticated) {
      await this.refreshAccountList();
      await this.workspaceList();
      this.dataLoading = false;
      window.$bus.on("refreshAccountList", this.refreshAccountList);
      //console.log("Seller Central Page Mounted");
      this.updateTotalData();
      this.checkIfAnyPreviousAccountRemoveTaskIsRunning();
    }
  },
  beforeUnmount() {
    window.$bus.off("refreshAccountList", this.refreshAccountList);
  },
  methods: {
    ...mapActions(["accountList", "accountAuthorize", "accountRemove", "authStatus", "workspaceList", "setBreadcrumbs", "accountUpdate"]),
    searchFilter(account) {
      if (!this.search) return true;
      return (account.account_name || "").toLowerCase().includes(this.search.toLowerCase());
    },
    accountsSort(a, b) {
      if (!this.sortType) {
        return b.account_id > a.account_id;
      }
      const sortMap = {
        name: this.sortByAccountName,
        type: this.sortByAccountType,
        status: this.sortByAccountStatus
      };
      return sortMap[this.sortType](a, b);
    },
    updateSortType(type) {
      if (this.sortType === type) {
        this.sortAscending = !this.sortAscending;
        return;
      }
      this.sortType = type;
      this.sortAscending = true;
    },
    sortByAccountName(a, b) {
      const comparison = a.account_name?.localeCompare(b.account_name);
      return this.sortAscending ? comparison : -comparison;
    },
    sortByAccountType(a, b) {
      const comparison = a.account_provider?.localeCompare(b.account_provider);
      return this.sortAscending ? comparison : -comparison;
    },
    sortByAccountStatus(a, b) {
      const a_status = a.credential_status ?? "Unknown";
      const b_status = b.credential_status ?? "Unknown";
      const comparison = a_status?.localeCompare(b_status);
      return this.sortAccountNameAscending ? comparison : -comparison;
    },
    onRemove(account) {
      this.removeId = account.account_id;
      this.removeAccount = account;
      this.confirmRemoveModal = true;
    },
    workspaceName(workspace_id) {
      let found_workspace = this.workspaceNameById(workspace_id);
      return found_workspace ? found_workspace : "";
    },
    handleIdle() {
      this.removeLoading = false;
    },
    handleFailed() {
      this.removeLoading = false;
    },
    handleRunning(data) {
      this.removeLoading = true;
      this.checkTaskStatusPeriodically(data?.task_id);
    },
    handleFinished(data) {
      this.removeLoading = false;
      this.removeId = null;
      if (this.asyncUpdateInterval) {
        clearTimeout(this.asyncUpdateInterval);
        this.asyncUpdateInterval = null;
      }
      ;
      window.$bus.trigger("showSuccess", {
        visible: true,
        message: data.task_status + data.task_result.status,
        delay: 60 // Show alert less than 1 minute
      });
      this.refreshAccountList();
    },
    async onRemoveConfirm() {
      this.confirmRemoveModal = false;
      this.removeLoading = true;
      let advertisingAccounts = this.accountAdvertisingBySellerIdGet(this.removeId);
      let seller_list = [{
        account_id: this.removeId.toString()
      }, ...advertisingAccounts].map(item => {
        return {
          account_id: item.account_id.toString()
        };
      });
      this.accountRemoveTaskIdentifier = this.current_workspace.workspace_id + "_" + this.removeId + "_" + "accounts_delete";
      let account_remove_task = await this.accountRemove({
        seller_list: seller_list,
        task_identifier_omny: this.accountRemoveTaskIdentifier,
        workspace_id: this.current_workspace.workspace_id.toString()
      });
      this.getAsyncUpdate(account_remove_task.task_id);
      this.checkTaskStatusPeriodically(account_remove_task.task_id);
    },
    async refreshAccountList() {
      let data = {};
      //sessionStorage.setItem("useFaker", true);
      await Promise.all([this.accountList(data)]);
      //sessionStorage.setItem("useFaker", false);
    },
    updateTotalData() {
      this.$emit("update-total", {
        totalPages: this.accounts?.length
      });
    },
    checkIfAnyPreviousAccountRemoveTaskIsRunning() {
      for (const account in this.accounts) {
        this.removeId = account.account_id;
        this.accountRemoveTaskIdentifier = this.current_workspace.workspace_id + "_" + account.account_id + "_" + "accounts_delete";
        this.getAsyncUpdate(this.accountRemoveTaskIdentifier);
        this.checkTaskStatusPeriodically(this.accountRemoveTaskIdentifier);
        for (const profile in this.accountAdvertisingBySellerIdGet(account.account_id)) {
          this.removeId = profile.account_id;
          this.accountRemoveTaskIdentifier = this.current_workspace.workspace_id + "_" + profile.account_id + "_" + "accounts_delete";
          this.getAsyncUpdate(this.accountRemoveTaskIdentifier);
          this.checkTaskStatusPeriodically(this.accountRemoveTaskIdentifier);
        }
      }
      ;
    },
    async onConnect(account, provider = "Amazon Advertising") {
      const data = {
        region: account.region,
        account_provider: provider,
        workspace_id: account.workspace_id,
        amz_sp_api_seller_id: account.selling_partner_id,
        country: country_codes[account.country],
        account_type: this.accountTypes[account.account_provider]
      };
      this.loading = true;
      await this.accountAuthorize(data);
      this.loading = false;
    },
    onOpenAdsSideBar(account) {
      this.sideBarAccount = account;
      this.advertisingAccountSideBar = true;
    },
    onOpenDSPSideBar(account) {
      this.sideBarAccount = account;
      this.dspAccountSideBar = true;
    },
    async refreshAdvertisingAccountSideBar(account_object) {
      //console.log('Refresh account called');
      await this.refreshAccountList();
      // const refresh_account = this.accountsList.find(
      //   (account) => account.account_id === account_object.account_id
      // );
      // this.advertisingAccountSideBar = false;
      // this.sideBarAccount = {
      //   account: refresh_account,
      //   type: account_object.type,
      // };
      // this.advertisingAccountSideBar = true;
    },
    async refreshDSPAccountSideBar(account_object) {
      //console.log('Refresh account called');
      await this.refreshAccountList();
      // const refresh_account = this.accountsList.find(
      //   (account) => account.account_id === account_object.account_id
      // );
      // this.dspAccountSideBar = false;
      // this.sideBarAccount = {
      //   account: refresh_account,
      //   type: account_object.type,
      // };
      // this.dspAccountSideBar = true;
    },
    async reauthenticateAccount(account) {
      const payload = {
        region: account.region,
        account_provider: account.account_provider,
        workspace_id: account.workspace_id,
        country: account.country
      };
      await this.accountAuthorize(payload);
    },
    onAccountNameClick(account) {
      if (account.account_provider !== "Amazon Vendor Central") {
        return;
      }
      if (!this.accountNameEditId || this.accountNameEditId !== account.account_id) {
        this.accountNameEditId = account.account_id;
      }
    },
    splitAccountName(account_name) {
      const splitted_name = account_name?.split(" - ");
      return {
        name: splitted_name[0],
        country: splitted_name[1],
        type: splitted_name[2]
      };
    },
    onAccountNameChange(event, account) {
      const new_account_name = event.target.value;
      const split_account_name = this.splitAccountName(account.account_name);
      this.updatedAccount = {
        ...account,
        account_name: [new_account_name, split_account_name.country, split_account_name.type].join(" - ")
      };
      this.confirmAccountNameEditModal = true;
    },
    async onConfirmAccountNameEdit() {
      this.confirmAccountNameEditModal = false;
      this.nameEditLoading = true;
      delete this.updatedAccount["_id"];
      delete this.updatedAccount.profiles;
      await this.accountUpdate(this.updatedAccount);
      this.updatedAccount = {};
      this.accountNameEditId = "";
      this.nameEditLoading = false;
    }
  }
};